export const iconStyle = {
  margin: 0,
};

// advanced care planning
export const ACP = 'ACP';
// Psychotherapy
export const PSY = 'PSY';
